import SubmissionDetails from './SubmissionDetails';

export default SubmissionDetails;
export type { SubmissionDetailsProps, SubmissionDetailsType } from './SubmissionDetails';
